import React, { createContext, useContext, useEffect, useState } from "react";
import { translations, LANGUAGES } from "@/data/translations";

const LanguageContext = createContext(null);

const detectInitial = () => {
  const saved = typeof window !== "undefined" ? localStorage.getItem("ob_lang") : null;
  if (saved && translations[saved]) return saved;
  const browser = typeof navigator !== "undefined" ? navigator.language?.slice(0, 2) : "en";
  return translations[browser] ? browser : "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitial);

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    localStorage.setItem("ob_lang", code);
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const value = { lang, setLang, t: translations[lang], languages: LANGUAGES };
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
